import { Button, ValidationError } from '../../components';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { ReportedUserManagementService } from '../../services';
import '../Modal/Modal.global.scss';
import './addnote.global.scss';

interface Props {
  handleModalClose: any;
  setShowOverlay: any;
  setNotification: any;
  id: any;
  intl: any;
}

const AddNote: React.FC<Props> = (props: Props) => {
  const {
    handleModalClose, id, intl, setShowOverlay, setNotification,
  } = props;
  const [message, setMessage] = useState('');
  const [smsNotificationError, setSMSNotificationError] = useState({
    message: '',
  });
  return (
    <div>
      <h2>
        {intl.formatMessage({ id: 'AddNote.label' })}
      </h2>
      <textarea
        placeholder="Enter message"
        onChange={(e) => {
          setMessage(e.target.value);
        }}
      />
      {smsNotificationError.message === 'empty'
        && <ValidationError error="Note cannot be empty" />}
      {smsNotificationError.message === 'greater'
        && <ValidationError error="Note cannot be greater than 150 alphabets" />}

      <div className="modalButtonWrapper">
        <Button
          className="margin_right"
          onClick={handleModalClose}
        >
          {intl.formatMessage({ id: 'AddNote.label.Cancel' })}
        </Button>
        <Button
          className="margin_right"
          onClick={() => {
            if (message.length === 0) {
              setSMSNotificationError({ ...smsNotificationError, message: 'empty' });
            } else if (message.length > 150) {
              setSMSNotificationError({ ...smsNotificationError, message: 'greater' });
            } else {
              setShowOverlay(true);
              ReportedUserManagementService.addNote({
                userId: id,
                description: message,
              }).then(() => {
                setNotification({
                  show: true,
                  message: 'Note added successfully',
                });
                setShowOverlay(false);
                handleModalClose();
              });
            }
          }}
        >
          {intl.formatMessage({ id: 'AddNote.label' })}
        </Button>
      </div>
    </div>
  );
};

export default injectIntl(AddNote);
